import checkBlack from './check-black.png';
import checkBlack2 from './check-black-2.png';
import checkWhite from './check-white.png';
import checkWhite2 from './check-white-2.png';
import closeBlack from './x-black.png';
import closeWhite from './x-white.png';
import createWhite from './create-white.png';
import fullscreenActiveBlack from './fullscreen-active-black.png';
import fullscreenActiveWhite from './fullscreen-active-white.png';
import fullscreenInactiveBlack from './fullscreen-inactive-black.png';
import fullscreenInactiveWhite from './fullscreen-inactive-white.png';
import homeBlack from './home-black.png';
import homeWhite from './home-white.png';
import largeIconActiveBlack from './large-icon-active-black.png';
import largeIconActiveWhite from './large-icon-active-white.png';
import largeIconBlack from './large-icon-black.png';
import largeIconWhite from './large-icon-white.png';
import leftArrowBlack from './left-arrow-black.png';
import leftArrowWhite from './left-arrow-white.png';
import menuBlack from './menu-black.png';
import menuWhite from './menu-white.png';
import notesHiddenIconBlack from './notes-hidden-icon-black.png';
import notesHiddenIconWhite from './notes-hidden-icon-white.png';
import notesVisibleIconBlack from './notes-visible-icon-black.png';
import notesVisibleIconWhite from './notes-visible-icon-white.png';
import printIconWhite from './print-icon-white.png';
import privacyEyeClosedBlack from './privacy-eye-closed-black.png';
import privacyEyeClosedWhite from './privacy-eye-closed-white.png';
import privacyEyeOpenBlack from './privacy-eye-open-black.png';
import privacyEyeOpenWhite from './privacy-eye-open-white.png';
import rightArrowBlack from './right-arrow-black.png';
import smallIconActiveBlack from './small-icon-active-black.png';
import smallIconActiveWhite from './small-icon-active-white.png';
import smallIconBlack from './small-icon-black.png';
import smallIconWhite from './small-icon-white.png';
import upArrowBlack from './up-arrow-black.png';
import uploadBlack from './upload-black.png';
import uploadWhite from './upload-white.png';

const icons = {
  check: {
    black: checkBlack,
    white: checkWhite
  },
  close: {
    white: closeWhite,
    black: closeBlack,
  },
  check2: {
    white: checkWhite2,
    black: checkBlack2
  },
  create: {
    white: createWhite,
  },
  fullscreenActive: {
    black: fullscreenActiveBlack,
    white: fullscreenActiveWhite
  },
  fullscreenInactive: {
    black: fullscreenInactiveBlack,
    white: fullscreenInactiveWhite
  },
  home: {
    black: homeBlack,
    white: homeWhite,
  },
  largeIconActive: {
    black: largeIconActiveBlack,
    white: largeIconActiveWhite,
  },
  largeIcon: {
    black: largeIconBlack,
    white: largeIconWhite,
  },
  leftArrow: {
    black: leftArrowBlack,
    white: leftArrowWhite,
  },
  menu: {
    black: menuBlack,
    white: menuWhite,
  },
  notesHidden: {
    black: notesHiddenIconBlack,
    white: notesHiddenIconWhite,
  },
  notesVisible: {
    black: notesVisibleIconBlack,
    white: notesVisibleIconWhite,
  },
  print: {
    white: printIconWhite,
  },
  privacyEyeOpen: {
    black: privacyEyeOpenBlack,
    white: privacyEyeOpenWhite
  },
  privacyEyeClosed: {
    black: privacyEyeClosedBlack,
    white: privacyEyeClosedWhite
  },
  rightArrow: {
    black: rightArrowBlack,
  },
  smallIconActive: {
    black: smallIconActiveBlack,
    white: smallIconActiveWhite,
  },
  smallIcon: {
    black: smallIconBlack,
    white: smallIconWhite,
  },
  upArrow: {
    black: upArrowBlack,
  },
  upload: {
    black: uploadBlack,
    white: uploadWhite,
  },
};

export default icons;